/**
 * Onglet « Historique des statuts » d'un OR (extrait de OrDetail.jsx — iter31).
 * Affiche la timeline ancien_statut → nouveau_statut + horodatage + utilisateur + commentaire.
 */
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ChevronRight } from "lucide-react";

export default function OrHistoriqueTab({ historique, statutLabels, statutColors }) {
  return (
    <Card className="p-5 border-gray-200">
      <h3 className="font-heading font-semibold mb-3">Historique des statuts</h3>
      {historique.length === 0 ? (
        <div className="text-sm text-gray-400">Aucun changement de statut enregistré.</div>
      ) : (
        <ol className="space-y-3">
          {historique.map((h) => (
            <li
              key={h.id}
              className="flex items-start gap-3"
              data-testid={`historique-${h.id}`}
            >
              <div className="w-6 h-6 rounded-full bg-[#52a675]/10 flex items-center justify-center flex-shrink-0">
                <ChevronRight className="w-3 h-3 text-[#52a675]" />
              </div>
              <div className="flex-1">
                <div className="text-sm">
                  <Badge
                    variant="outline"
                    className={`${statutColors[h.ancien_statut]} text-[10px]`}
                  >
                    {statutLabels[h.ancien_statut]}
                  </Badge>
                  <span className="text-gray-400 mx-1">→</span>
                  <Badge
                    variant="outline"
                    className={`${statutColors[h.nouveau_statut]} text-[10px]`}
                  >
                    {statutLabels[h.nouveau_statut]}
                  </Badge>
                </div>
                <div className="text-xs text-gray-500 mt-0.5">
                  {new Date(h.date).toLocaleString("fr-CH", {
                    day: "2-digit",
                    month: "short",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}{" "}
                  · {h.user_nom}
                </div>
                {h.commentaire && (
                  <div className="text-xs text-gray-600 mt-1 italic">
                    "{h.commentaire}"
                  </div>
                )}
              </div>
            </li>
          ))}
        </ol>
      )}
    </Card>
  );
}
